import * as Msdyn365 from '@msdyn365-commerce/core';
import { ORDER_DETAILS_EASP_DOCUMENT_TYPES } from '../../configuration';
import { ensureAuthenticated } from '../../utilities/is-authenticated';
import { trackedAction } from '../../utilities/track-execution-time';

/**
 * GetEaspDocuments Input Action
 */
export class GetEaspDocumentsInput implements Msdyn365.IActionInput {
    public productId: string;
    public businessUnit: string;
    public documentType: string;
    public region: string;
    public company: string;
    public language: string;

    constructor(
        productId: string,
        businessUnit: string,
        documentType: string = ORDER_DETAILS_EASP_DOCUMENT_TYPES,
        region: string = '',
        company: string = '',
        language: string = ''
    ) {
        this.productId = productId;
        this.businessUnit = businessUnit;
        this.documentType = documentType;
        this.region = region;
        this.company = company;
        this.language = language;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () =>
        `GetEaspDocuments-${this.productId}-${this.businessUnit}-${this.documentType}-${this.region}-${this.company}-${this.language}`;
    public getCacheObjectType = () => 'GetEaspDocuments';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetEaspDocumentsData {
    '@odata.context'?: string;
    value: IGetEaspDocumentItem[];
}

export interface IGetEaspDocumentItem {
    DocumentId: string;
    FileName: string;
    DownstreamSystem: string;
    ProductId: string;
    Url: string;
    Summary: string;
    Language: string;
    Name?: string;
    BusinessUnit?: string;
    DocumentType?: string;
    Region?: string;
    Company?: string;
    RecordCreatedDate: Date;
    ExtensionProperties: unknown[];
}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetEaspDocumentsInput('', '', ORDER_DETAILS_EASP_DOCUMENT_TYPES, '', '', '');
};

async function action(input: GetEaspDocumentsInput, ctx: Msdyn365.IActionContext): Promise<IGetEaspDocumentsData> {
    ensureAuthenticated(ctx);
    let getEaspDocumentsData: IGetEaspDocumentsData = {} as IGetEaspDocumentsData;

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/Document/GetDownloadMetaData`,
        'post',
        {
            downloadRequest: {
                ProductId: input.productId,
                BusinessUnit: input.businessUnit,
                Region: input.region,
                Company: input.company,
                Language: input.language,
                Type: input.documentType
            }
        },
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            },
            timeout: 30000
        }
    )
        .then(res => {
            getEaspDocumentsData = res?.data as IGetEaspDocumentsData;
        })
        .catch(error => {
            return { error: { errorCode: error.response.status, errorText: error.response.statusText } };
        });
    return getEaspDocumentsData;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetEaspDocumentsData>>((input, ctx) => trackedAction(action, input, ctx, 'GetEaspDocuments')),
    id: 'GetEaspDocuments',
    input: createInput
});
